/**
 * ชื่อเอกสาร (vectordbName) ที่ระบบตั้งเอง — wizard / คิวอัปโหลดของ Model Creator (assistantSetupWizard.runner.js buildDocName)
 * ต่อท้ายชื่อไฟล์ด้วย "__" + a-z0-9 10 ตัว กันชนกับเอกสารของหน่วยงานอื่น (backend อ้างอิงเอกสารด้วยชื่ออย่างเดียว)
 *
 * ชื่อเต็มคือ key ของเอกสาร — ฟังก์ชันในไฟล์นี้ใช้กับ "ข้อความที่แสดง" เท่านั้น
 * ⚠️ ห้ามใช้กับค่าที่ส่ง API / v-model / item-value / route query ไม่งั้นหาเอกสารไม่เจอหรือไปลบ/แก้ผิดตัว
 *
 * ชื่อที่ผู้ใช้ตั้งเอง (เมนู Documents) และชื่อเก่าของ wizard ("-xxxxxx") ไม่ตรงรูปแบบนี้ → แสดงเหมือนเดิมทุกตัวอักษร
 */

export const DOC_NAME_SUFFIX_SEPARATOR = '__';
export const DOC_NAME_SUFFIX_LENGTH = 10;

const GENERATED_SUFFIX = new RegExp(`${DOC_NAME_SUFFIX_SEPARATOR}[a-z0-9]{${DOC_NAME_SUFFIX_LENGTH}}$`);
// ส่วนต่อท้ายของแต่ละชื่อในข้อความที่มีหลายชื่อ: ก่อนหน้าต้องเป็นอักขระของชื่อ และตามด้วยอักขระที่ไม่ใช่ของชื่อ/จบข้อความ
// (ชุดอักขระเดียวกับที่ backend ยอมให้อยู่ในชื่อ — ChatKMBAL.ValidCharactersRegex)
const NAME_CHAR = 'a-zA-Z0-9\\u0E00-\\u0E7F_-';
const GENERATED_SUFFIX_IN_TEXT = new RegExp(
  `(?<=[${NAME_CHAR}])${DOC_NAME_SUFFIX_SEPARATOR}[a-z0-9]{${DOC_NAME_SUFFIX_LENGTH}}(?![${NAME_CHAR}])`,
  'g',
);

/** ชื่อสำหรับแสดงผล: ตัดส่วนต่อท้ายที่ระบบสุ่ม · ตัดแล้วว่าง/ไม่ใช่ string → คืนค่าเดิม */
export function displayDocName(name) {
  if (typeof name !== 'string') return name;
  return name.replace(GENERATED_SUFFIX, '') || name;
}

/**
 * ค่าที่มีชื่อเอกสารหลายชื่อ — array หรือข้อความ เช่น JSON array string ของ config โมเดล ('["คู่มือ__…","FAQ"]')
 * ซ่อนส่วนต่อท้ายของทุกชื่อ โดยคงรูปแบบข้อความเดิม (เครื่องหมายคำพูด/จุลภาค/เว้นวรรค)
 */
export function displayDocNames(value) {
  if (Array.isArray(value)) return value.map(displayDocName);
  if (typeof value !== 'string') return value;
  return value.replace(GENERATED_SUFFIX_IN_TEXT, '');
}

/**
 * item-title ของ v-select / v-autocomplete รายการเอกสาร — รับได้ทั้ง { name } (GetDDVectorDBName / GetDDLVector) และ string
 * ใช้ reference เดียวนี้เสมอ (ไม่เขียน arrow ใน template): function ใหม่ทุก render ทำให้ Vuetify สร้าง items ใหม่
 * แล้วเขียนทับช่องค้นหาที่ผู้ใช้กำลังพิมพ์ (ดู utils/modelDropdown.js)
 */
export function docItemTitle(item) {
  return displayDocName(item !== null && typeof item === 'object' ? item.name : item);
}
